export const COMPONENT_NAMES = {
  RECENT_LIVE_STREAMING: 'recent-live-streaming',
}
